import { render, staticRenderFns } from "./NotificationsWidget.vue?vue&type=template&id=229585f4&scoped=true"
import script from "./NotificationsWidget.vue?vue&type=script&lang=js"
export * from "./NotificationsWidget.vue?vue&type=script&lang=js"
import style0 from "./NotificationsWidget.vue?vue&type=style&index=0&id=229585f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229585f4",
  null
  
)

export default component.exports